// src/pages/SelectionOrg.js
import React from "react";
import { useAuth } from "../contexts/AuthContext";

export default function SelectionOrg() {
  const { orgs, switchOrg, deconnecter, currentUser, creerNouvelleOrg } = useAuth();
  const [newOrgNom, setNewOrgNom] = React.useState("");
  const [creating, setCreating] = React.useState(false);
  const [showCreate, setShowCreate] = React.useState(false);

  async function handleCreate(e) {
    e.preventDefault();
    if (!newOrgNom.trim()) return;
    setCreating(true);
    try {
      await creerNouvelleOrg(newOrgNom.trim());
    } catch { alert("Erreur lors de la création."); }
    setCreating(false);
  }

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.header}>
          <span style={s.logo}>🎟️</span>
          <h1 style={s.title}>TomboLive</h1>
          <p style={s.subtitle}>Choisissez votre association</p>
        </div>

        <p style={s.email}>{currentUser?.email}</p>

        <div style={s.orgList}>
          {orgs.map(({ org, role }) => (
            <button key={org.id} onClick={() => switchOrg(org.id)} style={s.orgBtn}>
              <div style={s.orgLeft}>
                <div style={s.orgAvatar}>{org.nom.charAt(0).toUpperCase()}</div>
                <div>
                  <div style={s.orgNom}>{org.nom}</div>
                  <div style={s.orgRole}>
                    {role === "admin" ? "👑 Admin" : "🤝 Bénévole"}
                    <span style={org.plan === "pro" ? s.badgePro : s.badgeStarter}>
                      {org.plan === "pro" ? "Pro" : "Starter"}
                    </span>
                  </div>
                </div>
              </div>
              <span style={s.chevron}>→</span>
            </button>
          ))}
        </div>

        {/* Créer une nouvelle organisation */}
        {!showCreate ? (
          <button onClick={() => setShowCreate(true)} style={s.btnCreate}>
            + Créer une nouvelle association
          </button>
        ) : (
          <form onSubmit={handleCreate} style={s.createForm}>
            <input type="text" placeholder="Nom de l'association ou du club"
              value={newOrgNom} onChange={(e) => setNewOrgNom(e.target.value)}
              required style={s.input} autoFocus />
            <div style={s.createBtns}>
              <button type="button" onClick={() => setShowCreate(false)} style={s.btnCancel}>
                Annuler
              </button>
              <button type="submit" disabled={creating || !newOrgNom.trim()} style={s.btnSubmit}>
                {creating ? "…" : "Créer"}
              </button>
            </div>
          </form>
        )}

        <button onClick={deconnecter} style={s.btnLogout}>Se déconnecter</button>
      </div>
    </div>
  );
}

const s = {
  wrapper: { minHeight:"100vh", background:"linear-gradient(135deg,#1a3a8f,#764ba2)", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem 1rem" },
  card: { background:"#fff", borderRadius:"20px", width:"100%", maxWidth:"420px", padding:"2rem", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" },
  header: { textAlign:"center", marginBottom:"1rem" },
  logo: { fontSize:"2.5rem" },
  title: { fontSize:"1.5rem", fontWeight:"800", color:"#1a3a8f", margin:"0.25rem 0 0" },
  subtitle: { fontSize:"0.9rem", color:"#888", margin:"0.25rem 0 0" },
  email: { textAlign:"center", fontSize:"0.82rem", color:"#aaa", marginBottom:"1.5rem" },
  orgList: { display:"flex", flexDirection:"column", gap:"10px", marginBottom:"1.25rem" },
  orgBtn: { display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", padding:"1rem", background:"#f7f8fc", border:"1.5px solid #e8e8e8", borderRadius:"12px", cursor:"pointer", textAlign:"left", transition:"all 0.15s" },
  orgLeft: { display:"flex", alignItems:"center", gap:"12px" },
  orgAvatar: { width:"44px", height:"44px", borderRadius:"50%", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:"800", fontSize:"1.2rem", flexShrink:0 },
  orgNom: { fontWeight:"700", color:"#1a1a2e", fontSize:"0.95rem" },
  orgRole: { display:"flex", alignItems:"center", gap:"6px", fontSize:"0.78rem", color:"#888", marginTop:"2px" },
  badgePro: { background:"#ffc107", color:"#fff", borderRadius:"10px", padding:"1px 8px", fontSize:"0.7rem", fontWeight:"700" },
  badgeStarter: { background:"#e0e0e0", color:"#666", borderRadius:"10px", padding:"1px 8px", fontSize:"0.7rem", fontWeight:"600" },
  chevron: { color:"#667eea", fontWeight:"700", fontSize:"1.1rem" },
  btnCreate: { width:"100%", padding:"0.75rem", background:"none", border:"1.5px dashed #c7d2ff", borderRadius:"12px", color:"#667eea", fontWeight:"600", cursor:"pointer", fontSize:"0.9rem", marginBottom:"1rem" },
  createForm: { marginBottom:"1rem" },
  input: { width:"100%", padding:"0.7rem 1rem", border:"1.5px solid #e0e0e0", borderRadius:"10px", fontSize:"0.95rem", outline:"none", boxSizing:"border-box", marginBottom:"8px" },
  createBtns: { display:"flex", gap:"8px" },
  btnCancel: { flex:1, padding:"0.65rem", background:"#f5f5f5", border:"1px solid #ddd", borderRadius:"8px", cursor:"pointer", fontWeight:"600" },
  btnSubmit: { flex:1, padding:"0.65rem", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"700" },
  btnLogout: { width:"100%", padding:"0.65rem", background:"none", border:"none", color:"#aaa", fontSize:"0.85rem", cursor:"pointer" },
};
